import { render, staticRenderFns } from "./SettingsSubscribersModal.vue?vue&type=template&id=084c11b5&scoped=true&"
import script from "./SettingsSubscribersModal.vue?vue&type=script&lang=js&"
export * from "./SettingsSubscribersModal.vue?vue&type=script&lang=js&"
import style0 from "./SettingsSubscribersModal.vue?vue&type=style&index=0&id=084c11b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084c11b5",
  null
  
)

export default component.exports